export default function* clinicianSaga() {
	// See example in containers/HomePage/saga.js
}
